<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        12.18
        <br />2015
      </span>
      <span class="tiel">美菜网CEO刘传军：餐饮B2B创业迎来新机遇</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/f964e7833ea5244af0c4a1d1d97b48e7.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        2015年11月7日，“湖南省第二届移动互联网创新创业大会”在湖南长沙举行。
        <br />
        <br />本届大会以“移动互联，链接未来”为主题，共同探讨移动互联网发展趋势，寻求移动互联网企业与传统企业在O2O时代下合作共赢的机会。美菜网CEO刘传军参加了本次大会，并在移动互联网+餐饮论坛中发表了“餐饮B2B创业新机遇”的主题演讲。
        <br />
        <br />刘传军在演讲中提到：中国的餐饮原材料采购市场规模巨大，但也有很多市场痛点亟待解决。中国有5万亿农产品交易规模，核心城市有超过200万家餐厅，9000亿+的采购规模。而面对如此大的市场，中国的农产品供应链尤其低效。需求端无专业的送货服务。上游供给端没有持续稳定的订单。流通环节的成本占比高达60%以上。所以，对于中国的农产品交易市场来说，急需一场革命，移动互联网的浪潮带来了千载难逢的机会，而餐饮B2B创业也迎来了新机遇。
        <br />
        <br />同时，在大会期间，刘传军还作为嘉宾与湖南金鹰995广播电台的听众进行了交流互动。
        <br />
        <br />美菜简介： 2014年6月6日，北京云杉信息技术有限公司旗下的美菜网成立。 作为中国领先的农产品移动电商平台，美菜网一直致力于用前卫的理念和先进的科技颠覆中国农业市场。致力于帮助全国近千万家餐厅做采购。致力于打通从地头到终端的农产品供应链，缩短农产品流通环节，降低商户供应链成本，减少供应链人力。全流程精细化管控菜品从田间到餐桌的每一处细节。同时可提高农民收入，减少压货风险，降低农民损失，促进资源合理分配。截至2015年上半年，与美菜合作过的商户已超10万家，美菜为商户免费配送已累计超过500万次。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
